import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';
import { Component, Inject } from '@angular/core';


@Component({
    selector: 'packageImportModalComponent',
    styleUrls: ['./package-import-modal.component.scss'],
    templateUrl: './package-import-modal.component.html'
})
export class PackageImportModalComponent {
    public objListOpen = false;

    constructor(public modalComponentRef: BzgModalRef, @Inject(BZG_MODAL_DATA) public data: any) { }

    close() {
        this.modalComponentRef.close();
    }

    confirm() {
        this.modalComponentRef.close('confirm');
    }

    getListCommaSeparated() {
        return this.data.objList ? this.data.objList.join(', ') : '';
    }
}
